import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(1);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const cycle = () => {
      showTimer = window.setTimeout(() => {
        setMinutesAgo(Math.floor(Math.random() * 6) + 1);
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % purchaseNotifications.length);
        }, 5500);
      }, 3000);
    };
    cycle();
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [index, dismissed]);
  if (dismissed) return null;
  const person = purchaseNotifications[index];
  return <AnimatePresence data-id="element-53" data-mp="1z5kjvi3wlrvq">
      {visible ? <motion.aside initial={{
      x: -24,
      y: 12,
      opacity: 0,
      scale: 0.96
    }} animate={{
      x: 0,
      y: 0,
      opacity: 1,
      scale: 1
    }} exit={{
      x: -24,
      opacity: 0,
      scale: 0.96
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 z-50 w-[min(19rem,calc(100vw-1.5rem))] rounded-2xl border border-navy/10 bg-white p-3 shadow-lift sm:bottom-28 sm:left-5" aria-live="polite" data-id="element-54" data-mp="1z49gvkia8o5o">
          <div className="flex items-start gap-3" data-id="element-55" data-mp="1kg6bac85jehe">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-rose-mist text-lg" data-id="element-56" data-mp="1kfddi0r67zbe">
              {person.flag}
            </span>
            <div className="min-w-0 flex-1" data-id="element-57" data-mp="rssimqbhl533">
              <p className="truncate text-[13px] font-bold text-navy" data-id="element-58" data-mp="rpy054c19ucb">
                {person.name} · {person.country}
              </p>
              <p className="text-[12.5px] font-semibold leading-snug text-rose" data-id="element-59" data-mp="201hndnxlf155">
                Just purchased 5-MIN MENOPAUSE™
              </p>
              <p className="mt-1 flex items-center gap-1 text-[10.5px] font-semibold uppercase tracking-wide text-navy/50" data-id="element-60" data-mp="1v2oanxq4re61">
                <BadgeCheckIcon className="h-3 w-3 text-teal" aria-hidden="true" data-id="element-61" data-mp="28w5wjp6ah2z8" />
                {minutesAgo} min ago · Verified purchase
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="-mr-1 -mt-1 rounded-lg p-1 text-navy/35 transition-colors duration-150 ease-out hover:bg-navy/5 hover:text-navy" aria-label="Dismiss notification" data-id="element-62" data-mp="1h3f7byn0wejh">
              <XIcon className="h-3.5 w-3.5" data-id="element-63" data-mp="1l3finaets9mb" />
            </button>
          </div>
        </motion.aside> : null}
    </AnimatePresence>;
}